export function validateEmail(email: string): boolean {
  // See https://www.regular-expressions.info/email.html - Practical implementation of RFC 5322
  const regex =
    /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/;
  if (!regex.test(email)) {
    return false;
  }
  return true;
}
